import { Button } from '@/components/mira';
import * as Sentry from '@sentry/browser';

import { useResendEmailMutation } from 'redux/services/update-password';
import {onboarding_logo} from 'constants/constant.js';
import { useToast } from '@/hooks/use-toast';
import styles from '@/styles/features/auth/auth-pages.module.css';

const VerifyEmail = () => {
  const { toast } = useToast();

  const searchParams = new URLSearchParams(window.location.search);
  const sessionToken = searchParams.get('session_token');
  const [
    resendEmailAPI,
    { isLoading: isResendEmailLoading, isSuccess: isResendEmailSentSuccess },
  ] = useResendEmailMutation();

  //redirect to main page
  const handleRedirect = async () => {
    window.location.href = window.location.origin;
  };

  const resendEmail = async () => {
    try {
      const resp = await resendEmailAPI({
        data: {},
        token: sessionToken,
      });
      if (resp?.data?.status === 200) {
        toast({ title: 'Email is sent successfully.' });
      } else if (resp?.data?.status === 204) {
        toast({
          title: 'User is verified. Please continue to Login',
        });
      } else if (resp?.error?.status === 401) {
        window.location.href = `${window.location.origin}/session-timeout`;
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  return (
    <div
      className={`bg-cover bg-center h-screen flex flex-col justify-center items-center w-[100vw] ${styles.appBackground} ${styles.smallBodyText}`}
    >
      <div className="w-[500px] h-[134px] bg-secondary100 flex flex-col justify-center items-center">
        <img
          src={onboarding_logo}
          alt=""
          className="h-auto w-40 "
        />
        <h3 className="text-neutral900 h4-m mt-2">Pending verification</h3>
      </div>
      <div className="w-[500px] h-[42px] bg-green_success flex items-center justify-center text-white p-sm-bold">
        {isResendEmailSentSuccess
          ? 'VERIFICATION EMAIL RE-SENT'
          : 'VERIFICATION EMAIL SENT'}
      </div>
      <div className="w-[500px] h-[170px] bg-white flex flex-col justify-between py-6 items-center relative">
        <div className="text-center mb-4 px-7">
          <div className="font-medium leading-none ">
            A verification email has been sent to your registered email address.
            Please check your email and click on{' '}
            <span className="font-medium-bold">“Confirm my account”</span> to
            verify your account.
          </div>
          <div className="font-medium leading-none mt-14">
            Didn&apos;t receive the email?{' '}
            <Button variant="link" className={styles.linkButtonReset} onClick={resendEmail}>
              {isResendEmailLoading ? 'Please wait...' : 'Resend Email'}
            </Button>
          </div>
        </div>
      </div>
      <button
        onClick={handleRedirect}
        className="w-[500px] h-[70px] bg-primary500 hover:bg-primary600 flex flex-col justify-center items-center cursor-pointer"
      >
        <span className="p-md-bold mt-2 text-white">
          Click here to Login &gt;
        </span>
      </button>
    </div>
  );
};

export default VerifyEmail;
